import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { Box } from '@material-ui/core';

import {
	AppState,
	AppThunkDispatch,
	MapSearchResult,
	Project,
	searchChangePage,
	SearchPaginationAction,
	SearchResultState
} from '../../../redux';
import { SearchResultSort, MapCardContainer } from '..';
import { MapDto } from '../../../models';
import { Body1 } from '../../atoms';

import './search-result-list.styles.scss';
import { ScrollReset } from '../../../utils';
import { Pagination } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';

export interface ISearchResultListOwnProps {
	onMapClicked: (map: MapSearchResult) => void;
	onMapPreview?: (map: MapSearchResult) => void;
	projectSelection?: Project[];
}

export interface ISearchResultListStateProps {
	resultState: SearchResultState;
	changePage: (page: number) => void;
}

function SearchResultListView(
	props: ISearchResultListStateProps & ISearchResultListOwnProps
): ReactElement {
	const {
		onMapClicked,
		onMapPreview,
		projectSelection,
		resultState,
		changePage
	} = props;

	const { t } = useTranslation('search');

	function onPageChange(page: number): void {
		if (
			page < 0 ||
			page >= resultState.totalPages ||
			page === resultState.page
		) {
			return;
		}
		window.dispatchEvent(new Event(ScrollReset));
		changePage(page);
	}

	function handleMapPreview(map: MapSearchResult | MapDto): void {
		if (onMapPreview) onMapPreview(map as MapSearchResult);
	}

	return (
		<Box className="search-result-list">
			<Box className="search-result-list-header">
				<Body1>
					{resultState.count}{' '}
					{resultState.count === 1
						? t('result').toLowerCase()
						: t('results').toLowerCase()}
				</Body1>
				<SearchResultSort />
			</Box>
			<MapCardContainer
				onClick={(map: MapDto | MapSearchResult) =>
					onMapClicked(map as MapSearchResult)
				}
				onPreview={handleMapPreview}
				big
				maps={resultState.items}
				columns={3}
				selectable={projectSelection !== undefined}
				projectSelection={projectSelection}
			/>
			<Pagination
				className="results-paging"
				onChange={(_, page: number) => onPageChange(page - 1)}
				color="primary"
				count={resultState.totalPages}
				page={resultState.page + 1}
				size="large"
			/>
		</Box>
	);
}

function mapStateToProps(state: AppState) {
	return {
		resultState: state.search.searchResults
	};
}

function mapDispatchToProps(
	dispatch: AppThunkDispatch<SearchPaginationAction>
) {
	return {
		changePage: (page: number) => dispatch(searchChangePage(page))
	};
}

export const SearchResultList = connect(
	mapStateToProps,
	mapDispatchToProps
)(SearchResultListView);
